export default __webpack_public_path__ + "static/media/1_0068.b1f5c58b.webp";